<template><!--右侧路由窗口-->
  <el-tabs v-model="activeTab" type="card" @tab-remove="removeTab" @tab-click="clickTab">
    <el-tab-pane v-for="t in worktabs" :key="t.name" :label="t.tabname" :name="t.name" :closable="true">
    </el-tab-pane>
  </el-tabs>
</template>

<script>

export default {
  data() {
    return {
      activeTab: 'name'
    }
  },
  methods: {
    clickTab(tab) {
      this.$router.push(this.worktabs[1 * tab.index].path)
    },
    removeTab(name) {
      this.$store.dispatch('editableTabs/worktabRemove', name)
    }
  },
  created() {
    if (this.$isLogin() === false) {
      this.$notify({
        title: "未登录",
        message: "需要登录，请先登录",
        type: 'warning'
      });
      this.$router.push("/login");
    } else {
      this.activeTab = this.$store.state.editableTabs.worktab.current.name;
      this.$router.push(this.worktabs[0].path)
    }

  },
  watch: {
    '$store.state.editableTabs.worktab.current'(tab) {
      this.activeTab = tab.name
    }
  },
  computed: {
    worktabs() {
      return this.$store.state.editableTabs.worktab.list
    }
  },
}
</script>
